import { AABB, GameState, BuildingType } from './types';
import { TILE, PLAYER_SIZE } from './constants';

export function aabbOverlap(a: AABB, b: AABB): boolean {
  return a.x < b.x + b.w && a.x + a.w > b.x &&
         a.y < b.y + b.h && a.y + a.h > b.y;
}

export function getSolidAABBs(state: GameState): AABB[] {
  const solids: AABB[] = [];

  // World border walls
  solids.push({ x: -TILE, y: -TILE, w: (state.ground[0].length + 2) * TILE, h: TILE }); // top
  solids.push({ x: -TILE, y: state.ground.length * TILE, w: (state.ground[0].length + 2) * TILE, h: TILE }); // bottom
  solids.push({ x: -TILE, y: 0, w: TILE, h: state.ground.length * TILE }); // left
  solids.push({ x: state.ground[0].length * TILE, y: 0, w: TILE, h: state.ground.length * TILE }); // right

  // Solid buildings (walls)
  for (const b of state.buildings) {
    if (b.type === BuildingType.Wall) {
      solids.push({ x: b.gridX * TILE, y: b.gridY * TILE, w: TILE, h: TILE });
    }
  }

  // Living trees have collision
  for (const t of state.trees) {
    if (t.hp > 0) {
      // Tree trunk collision (smaller than full tile)
      const tx = t.gridX * TILE + 16;
      const ty = t.gridY * TILE + 24;
      solids.push({ x: tx, y: ty, w: 32, h: 40 });
    }
  }

  return solids;
}

export function moveAndSlide(
  x: number, y: number,
  dx: number, dy: number,
  size: number,
  solids: AABB[]
): { x: number; y: number } {
  const half = size / 2;

  // Try X movement
  let nx = x + dx;
  const xBox: AABB = { x: nx - half, y: y - half, w: size, h: size };
  for (const s of solids) {
    if (aabbOverlap(xBox, s)) {
      nx = x; // revert X
      break;
    }
  }

  // Try Y movement
  let ny = y + dy;
  const yBox: AABB = { x: nx - half, y: ny - half, w: size, h: size };
  for (const s of solids) {
    if (aabbOverlap(yBox, s)) {
      ny = y; // revert Y
      break;
    }
  }

  return { x: nx, y: ny };
}

export function pointInAABB(px: number, py: number, box: AABB): boolean {
  return px >= box.x && px < box.x + box.w && py >= box.y && py < box.y + box.h;
}

export function dist(x1: number, y1: number, x2: number, y2: number): number {
  const dx = x1 - x2;
  const dy = y1 - y2;
  return Math.sqrt(dx * dx + dy * dy);
}
